module.exports = __webpack_public_path__ + "static/media/community-gardens-about-2-sm.df3c5f44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/community-gardens-about-2-sm.jpg
// module id = 115
// module chunks = 11